/* eslint-disable hubspot-dev/no-private-classes */
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { useState } from 'react';
import { BounceContainer } from './components/BounceContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LowDisruptPrompt = ({
  children,
  title,
  icon,
  primaryColor,
  secondaryColor,
  onClickClose,
  id,
  width,
  onMountAnimationEnd,
  onUnmountAnimationEnd
}) => {
  const [showLowDisruptPrompt, setShowLowDisruptPrompt] = useState(true);
  return /*#__PURE__*/_jsx(View, {
    position: "fixed",
    insetBlockEnd: "90px",
    insetInlineEnd: "400",
    "data-test-id": id,
    children: /*#__PURE__*/_jsx(BounceContainer, {
      show: showLowDisruptPrompt,
      onMountAnimationEnd: onMountAnimationEnd,
      onUnmountAnimationEnd: () => {
        if (onUnmountAnimationEnd) {
          onUnmountAnimationEnd();
        }
      },
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: width ? `${width}px` : '460px',
        borderWidth: "100",
        borderStyle: "solid",
        borderRadius: "200",
        boxShadow: "300",
        borderColor: primaryColor,
        children: /*#__PURE__*/_jsxs(Flex, {
          backgroundColor: "fill-surface-default",
          children: [/*#__PURE__*/_jsx(Flex, {
            inlineSize: "70px",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: secondaryColor,
            children: icon && icon
          }), /*#__PURE__*/_jsxs(View, {
            paddingBlock: "500",
            paddingInline: "400",
            maxInlineSize: width ? `${width - 110}px` : '350px',
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              typography: "heading-100",
              marginBlockEnd: "400",
              marginInlineEnd: "400",
              children: title
            }), /*#__PURE__*/_jsx(View, {
              children: children
            })]
          }), /*#__PURE__*/_jsx(CloseButton, {
            "data-test-id": `${id}-close-button`,
            color: "icon-core-subtle",
            size: "lg",
            onClick: e => {
              setShowLowDisruptPrompt(false);
              if (onClickClose) {
                onClickClose(e);
              }
            }
          })]
        })
      })
    })
  });
};